import moment from 'moment';
import PropTypes from 'prop-types';
import { stringify } from 'query-string';
import React from 'react';
import styled from 'styled-components';

import useAPI from '@hooks/useAPI';
import Spinner from '@shared/Spinner';

import TrendChart from './TrendChart';

const getMatchByDate = (dateString, dateArray) => {
  const foundDate = dateArray.find(
    item =>
      moment(item).format('YYYY-MM-DD') ===
      dateString.format('YYYY-MM-DD')
  )

  return foundDate;
};

const ZERO = {
  Sum: 0,
};

const getAlertRate = (screenedSums, alertedSums) => {
  return screenedSums.map(item => {
    const alertItem = alertedSums.find(
      alertItem => item.Timestamp == alertItem.Timestamp
    );
    let sumValue = 0;
    if (item && item.Sum && alertItem && alertItem.Sum) {
      sumValue = alertItem.Sum / item.Sum;
    }
    return { ...item, Sum: sumValue };
  });
};

const Container = styled.div`
  margin-top: 25px;
  width: 100%;
`;

function getMetricsParams(
  startDate,
  endDate,
) {
  const formateDateTime = dateString => {
    return moment(dateString, 'YYYY-MM-DD').format();
  };

  return `${stringify({
    period: 24 * 60 * 60, // 1 day
    start_time: formateDateTime(startDate),
    end_time: formateDateTime(endDate),
  })}`;
}

function ScreenCharts({ selected, metricsAvailable, startDate, endDate }) {
  const params = getMetricsParams(startDate, endDate);
  const customer_id = process.env.REACT_APP_CUSTOMER_ID;

  const metricsFetcher = useAPI(
    'get',
    'ScreenConsoleApi',
    `config/metrics/${customer_id}/${selected}`,
    '',
    false,
    params,
    false
  );

  if (metricsFetcher.isLoading) {
    return <Spinner />;
  }

  let rawData = [];
  if (metricsFetcher.response) {
    rawData = metricsFetcher.response;
  }

  const compareByTime = (d1, d2) => {
    const date1 = new Date(d1.dateString);
    const date2 = new Date(d2.dateString);
    if (date1.valueOf() > date2.valueOf()) {
      return 1;
    } else if (date1.valueOf() < date2.valueOf()) {
      return -1;
    } else if (date1.valueOf() === date2.valueOf()) {
      return 0;
    }
  };

  const formatForChart = (item) => {
    const startDateMoment = moment(item.Timestamp);
    const newDateString = startDateMoment.format();
    let data = null;

    if('Data' in item){
      data = item.Data;
    }
    else if('Sum' in item){
      data = item.Sum;
    }
    else if('Average' in item){
      data = item.Average;
    }

    return {
      ...item,
      date: new Date(newDateString),
      data: data,
      dateString: newDateString
    }
  }
  const filledData = rawData.map(formatForChart)
  const sortedData = filledData.sort(compareByTime);
  return (
    <Container>
      <TrendChart metricData={sortedData} selected={selected} />
    </Container>
  );
}

ScreenCharts.propTypes = {
  selected: PropTypes.oneOf(['ALERTS', 'escalations', 'records']),
};

export default ScreenCharts;
